export const pillars = ['Electrical Design', 'Power Systems', 'Calculations & Technical Analysis', 'Automation & Control', 'Troubleshooting & Maintenance', 'Documentation & Reporting'];
export const volumes = [{
  n: 1,
  area: 'Electrical Design',
  title: 'The Design & Planning Framework',
  desc: 'Organize design requirements, clarify project constraints, structure technical requests, and prepare preliminary design documentation. Use prompts to identify missing inputs, compare possible approaches, and create structured drafts for qualified engineering review.'
}, {
  n: 2,
  area: 'Power Systems',
  title: 'The Power Systems Analysis Framework',
  desc: 'Structure requests involving electrical power systems, equipment information, system parameters, and technical analysis. Organize known inputs, document assumptions, and prepare reviewable summaries of power-system information.'
}, {
  n: 3,
  area: 'Electrical Calculations & Technical Analysis',
  title: 'The Calculation & Review Framework',
  desc: 'Structure calculation requests with clearly defined inputs, units, formulas, assumptions, and expected outputs. Use prompts to organize calculation steps, identify missing information, and prepare results for independent technical verification.'
}, {
  n: 4,
  area: 'Automation & Control Systems',
  title: 'The Automation & Control Framework',
  desc: 'Organize tasks involving automation requirements, control sequences, PLC functional specifications, and system behavior. Use structured prompts to clarify requirements, document inputs and outputs, and prepare technical drafts for professional review.'
}, {
  n: 5,
  area: 'Troubleshooting & Maintenance',
  title: 'The Fault Investigation Framework',
  desc: 'Approach electrical troubleshooting with a more organized information-gathering process. Structure prompts around symptoms, operating conditions, equipment information, potential causes, diagnostic evidence, and corrective-action records.'
}, {
  n: 6,
  area: 'Engineering Documentation & Reporting',
  title: 'The Technical Deliverables Framework',
  desc: 'Prepare structured drafts for technical reports, inspection records, maintenance documentation, specifications, and project handover. Use prompts to organize information, identify missing details, and improve the clarity of engineering documents.'
}];
export const volumeIncludes = ['Structured copy-and-adapt AI prompts', 'Customizable fields for project-specific information', 'Clear instructions for defining objectives and context', 'Guidance for organizing inputs, assumptions, and expected outputs', 'Practical engineering applications', 'Review-oriented checklists and verification guidance'];
export const bonuses = [{
  n: '01',
  title: 'The Electrical Engineer AI Quick-Start Vault™',
  subtitle: 'Your Practical Guide to Turning AI Into a Reliable Engineering Workflow Assistant',
  desc: 'Learn how to structure your first AI-assisted engineering workflows, provide useful context, define objectives, and organize prompts into a repeatable process.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/7BdW2d5gCsN7iTWC7mVmex/Guia_de_Diagnostico_Electrico_Industrialwaswo_(1).webp'
}, {
  n: '02',
  title: 'The Electrical Calculation Review Kit™',
  subtitle: 'Practical Worksheets for Electrical Calculations, Assumptions, Units & Independent Verification',
  desc: 'Organize calculation inputs, assumptions, formulas, units, and results with practical worksheets designed to support independent technical review.',
  price: '$29',
  cover: 'https://cdn.magicpatterns.com/uploads/x5VDLeESpj8Ef3Ds6QmJAX/Guia_de_Diagnostico_Electrico_Industrialwaswo_(2).webp'
}, {
  n: '03',
  title: 'The Electrical Troubleshooting Field Guide™',
  subtitle: 'A Structured System for Fault Investigation, Evidence Collection, Root Cause Analysis & Corrective Action Tracking',
  desc: 'Structure fault investigations, document symptoms and evidence, organize potential causes, and track findings and corrective actions for qualified review.',
  price: '$32',
  cover: 'https://cdn.magicpatterns.com/uploads/6oCS67hK6HmQGxiLXsGqLk/Guia_de_Diagnostico_Electrico_Industrialwaswo.webp'
}, {
  n: '04',
  title: 'The Engineering Report Template Vault™',
  subtitle: 'Ready-to-Adapt Templates for Electrical Engineering Reports, Inspections, Proposals, RFIs & Project Handover',
  desc: 'Prepare more organized technical documentation with reusable structures for reports, inspections, proposals, requests for information, and project handover.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/orDH54YpyT7vQvweq8rQz6/Guia_de_Diagnostico_Electrico_Industrialwaswo_(3).webp'
}];
